import { render, staticRenderFns } from "./GroupOrderOnboardingSheet.vue?vue&type=template&id=f3edcb2c&scoped=true&"
import script from "./GroupOrderOnboardingSheet.vue?vue&type=script&lang=js&"
export * from "./GroupOrderOnboardingSheet.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrderOnboardingSheet.vue?vue&type=style&index=0&id=f3edcb2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3edcb2c",
  null
  
)

export default component.exports